import api from "./api.js";

export default class NoticeApi {
  static async create(data) {
    return await api.post(`api/notice`, data);
  }

  static async getList(params) {
    return await api.get(`api/notice`, params);
  }

  static async delete(data) {
    return await api.del(`api/notice`, data);
  }

  static async getById(id) {
    return await api.get(`api/notice/${id}`);
  }

  static async update(id, data) {
    return await api.patch(`api/notice/${id}`, data);
  }
}
